"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AmplitudeTracker", {
  enumerable: true,
  get: function get() {
    return _amplitude.AmplitudeTracker;
  }
});
Object.defineProperty(exports, "BaseTracker", {
  enumerable: true,
  get: function get() {
    return _base.BaseTracker;
  }
});
Object.defineProperty(exports, "FullStoryTracker", {
  enumerable: true,
  get: function get() {
    return _fullstory.FullStoryTracker;
  }
});
Object.defineProperty(exports, "GATracker", {
  enumerable: true,
  get: function get() {
    return _ga.GATracker;
  }
});
Object.defineProperty(exports, "GTMTracker", {
  enumerable: true,
  get: function get() {
    return _gtm.GTMTracker;
  }
});
Object.defineProperty(exports, "HotjarTracker", {
  enumerable: true,
  get: function get() {
    return _hotjar.HotjarTracker;
  }
});
Object.defineProperty(exports, "HubspotTracker", {
  enumerable: true,
  get: function get() {
    return _hubspot.HubspotTracker;
  }
});
Object.defineProperty(exports, "MixpanelTracker", {
  enumerable: true,
  get: function get() {
    return _mixpanel.MixpanelTracker;
  }
});
Object.defineProperty(exports, "UserRecorderTracker", {
  enumerable: true,
  get: function get() {
    return _userRecorder.UserRecorderTracker;
  }
});
exports.default = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _fullstory = require("./tracker/fullstory");
var _ga = require("./tracker/ga");
var _base = require("./tracker/base");
var _mixpanel = require("./tracker/mixpanel");
var _amplitude = require("./tracker/amplitude");
var _hubspot = require("./tracker/hubspot");
var _hotjar = require("./tracker/hotjar");
var _userRecorder = require("./tracker/user-recorder");
var _gtm = require("./tracker/gtm");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var debug = (0, _debug.default)('rentspree-tracker:main');

/**
 * The tracker class, this class will be the one place to trigger any tracking event
 * It will manage Instance that connect to each analytic provider
 * and call to track all of those providers api when one event occur.
 */
var Tracker = exports.default = /*#__PURE__*/function () {
  function Tracker() {
    _classCallCheck(this, Tracker);
    debug('Initialize Tracker class');
    this.trackers = [];
  }

  /**
   * Register the tracker Instance to track.
   * Each tracker must be initialize before register to the tracker
   * @example
   * const tracker = new Tracker()
   * const gaTracker = new GATracker({trackerId: "hello-tracker"})
   * tracker.registerTracker(gaTracker)
   * // with this the gaTracker event handler will be fired every time
   * // the tracker got an event
   * @param {BaseTracker} trackerInstance the tracker to be tracked
   */
  _createClass(Tracker, [{
    key: "registerTracker",
    value: function registerTracker(trackerInstance) {
      debug('pushing %o tracker to main tracker', trackerInstance);
      this.trackers.push(trackerInstance);
    }

    /**
     * pass track page view parameter to every registeredTracker
     * @param {String} url the url to track
     * @param {String} path the path to track
     * @param {Object} properties the additional properties object to be passed to trackers
     */
  }, {
    key: "trackPageView",
    value: function trackPageView(url, path) {
      var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var obj = {
        url: url,
        path: path,
        properties: properties
      };
      debug('track page view for object %0', obj);
      this.trackers.forEach(function (t) {
        return t.trackPageView && t.trackPageView(url, path, properties);
      });
    }

    /**
     * pass identify user parameter to every registered tracker
     * @param {Object} profile the profile object that will be passed through `mapUserIdentity`
     * and `mapUserProfile` for each tracker instance.
     */
  }, {
    key: "identifyUser",
    value: function identifyUser(profile) {
      debug('identify user %O', profile);
      this.trackers.forEach(function (t) {
        return t.identifyUser && t.identifyUser(profile);
      });
    }

    /**
     * pass identify user on the amplitude only
     * @param {Object} profile the profile object that will be passed through
     * `mapUserIdentity` and `mapUserProfile` for only amplitude tracker instance.
     */
  }, {
    key: "identifyAmplitude",
    value: function identifyAmplitude(profile) {
      debug('identify amplitude user %O', profile);
      this.trackers.forEach(function (t) {
        return t.identifyAmplitude && t.identifyAmplitude(profile);
      });
    }

    /**
     * pass track event parameter to every registered tracker
     * @param {String} eventName the event name
     * @param {Object} eventProperties the event properties object to be passed to trackers
     */
  }, {
    key: "trackEvent",
    value: function trackEvent(eventName, eventProperties) {
      debug('track event name:%s, withProp:%o', eventName, eventProperties);
      this.trackers.forEach(function (t) {
        return t.trackEvent && t.trackEvent(eventName, eventProperties);
      });
    }

    /**
     * track event button click with parameters
     * @param {Object} properties the event properties object to be passed to trackers
     * @param {Object} options the event custom options
     */
  }, {
    key: "trackButtonClick",
    value: function trackButtonClick(properties, options) {
      debug('track event name:%s, withProp:%o', 'button_click', properties);
      this.trackers.forEach(function (t) {
        return t.trackButtonClick && t.trackButtonClick(properties, options);
      });
    }

    /**
     * pass alias user parameter to every registered tracker
     * @param {String} alias the alias to define alias of user
     */
  }, {
    key: "setAliasUser",
    value: function setAliasUser(alias) {
      debug('set alias user with name:%s', alias);
      this.trackers.forEach(function (t) {
        return t.setAliasUser && t.setAliasUser(alias);
      });
    }

    /**
     * trigger logout method on each trackers
     */
  }, {
    key: "logout",
    value: function logout() {
      debug('=== RentSpree tracker logout method running... ===');
      this.trackers.forEach(function (t) {
        return t.logout && t.logout();
      });
    }
  }]);
  return Tracker;
}();